import { Avatar, Button, Card, Group, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";

export function GestionPersonalDetallesViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
)  {

    const personal_id = record[0] as string;
    const personal = record[1] as string;
    const puesto = record[2] as string;
    const vc_fotoguid = record[6] as string;

    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    {group.records.map(
                        ({ recordValue: rec }, index) => <Group key={`grp_${rec[0]}`}>
                            <Title order={5}>{`${rec[1]}`}</Title>
                            <Button size="xs" onClick={async () => {
                                await UIAPI.handleViewClick({ 'c_personal_id': rec[0] });
                            }} >Ver</Button>
                        </Group>
                    )
                    }
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {
        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Group spacing="xs">
                        <Avatar size="md" src={fotoURL} radius="sm" />
                        <Title order={4}>{`${personal}`}</Title>
                    </Group>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">Puesto: </Text>
                        {puesto}
                    </Group>
                    <Group position="right">
                        <Button size="xs" onClick={async () => {
                            await UIAPI.handleViewClick({ 'c_personal_id': personal_id });
                        }} >Ver</Button>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}